/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductLists_ProductListFragmentDoc } from './ProductLists.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductListOverviewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProductListOverviewQuery = { productLists: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProductListConnection', edges: Array<{ __typename: 'ProductListEdge', node: { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string } } }> } };


export const ProductListOverviewDocument = gql`
    query ProductListOverview($id: ID!) {
  productLists(limit: 1, filters: {ids: [$id]}) {
    ... on ProductListConnection {
      edges {
        node {
          ...ProductLists_ProductList
        }
      }
    }
  }
}
    ${ProductLists_ProductListFragmentDoc}`;

/**
 * __useProductListOverviewQuery__
 *
 * To run a query within a React component, call `useProductListOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductListOverviewQuery(baseOptions: Apollo.QueryHookOptions<ProductListOverviewQuery, ProductListOverviewQueryVariables> & ({ variables: ProductListOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListOverviewQuery, ProductListOverviewQueryVariables>(ProductListOverviewDocument, options);
      }
export function useProductListOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListOverviewQuery, ProductListOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListOverviewQuery, ProductListOverviewQueryVariables>(ProductListOverviewDocument, options);
        }
export function useProductListOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListOverviewQuery, ProductListOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListOverviewQuery, ProductListOverviewQueryVariables>(ProductListOverviewDocument, options);
        }
export type ProductListOverviewQueryHookResult = ReturnType<typeof useProductListOverviewQuery>;
export type ProductListOverviewLazyQueryHookResult = ReturnType<typeof useProductListOverviewLazyQuery>;
export type ProductListOverviewSuspenseQueryHookResult = ReturnType<typeof useProductListOverviewSuspenseQuery>;
export type ProductListOverviewQueryResult = Apollo.QueryResult<ProductListOverviewQuery, ProductListOverviewQueryVariables>;